import { createRouter, createWebHistory } from "vue-router";
const routes = [
    {
        // path: '/admin/form/serviceRequestForm/create',
        // name: 'createServiceRequestForm',
        // components: () => import('../views/admin/serviceRequest/serviceRequestCreate.vue'),
        // meta: {
        //     layout: 'admin'
        // }
    }
];

const router = createRouter({
    history: createWebHistory('/'),
    routes,
});

export default router;
